import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

export default function FeatureCard({ children, className }) {
  return (
    <motion.div
      variants={{
        hidden: { opacity: 0, y: 24 },
        visible: { opacity: 1, y: 0 },
      }}
      transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
      className={cn(
        "relative flex flex-col overflow-hidden rounded-3xl bg-[#F4F5F7] p-6 sm:p-8",
        "min-h-[380px] sm:min-h-[440px]",
        className
      )}
    >
      {children}
    </motion.div>
  );
}
